module.exports = "/assets/ae0ac0c8987434baa949f46e1646712d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/WB.png
// module id = 3073
// module chunks = 0